<template>
  <div>
    <canvas ref="pdfViewer" style="width:80%"></canvas>
  </div>
</template>

<script>
import * as pdfjs from 'pdfjs-dist'
export default {
  name: 'PDFViewer',
  props: {
    pdfUrl: {
      type: String,
      required: true
    }
  },
  mounted () {
    this.renderPDF()
  },
  methods: {
    
    async renderPDF () {
        console.log(pdfjs)
        console.log(this.pdfUrl)
      pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.js';
      console.log(pdfjs)
      const pdfData =await pdfjs.getDocument(this.pdfUrl).promise
      const page = await pdfData.getPage(1)
      const viewport = page.getViewport({ scale: 1 })

      const canvas = this.$refs.pdfViewer
      const context = canvas.getContext('2d')
    
      canvas.height = viewport.height*(96/72)
      canvas.width = viewport.width*(96/72)

       page.render({
        canvasContext: context,
        viewport: viewport,
        intent: 'print' 
      })
    }
  }
}
</script>